import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';
import { showTemporaryMessage } from "../components/Message";
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import logoicon from '../images/tuutuum-logo-icon.png';
import LanguageSwitcher from '../components/LanguageSwitcher';

import MultiDiseaseSelector from "../components/MultiDiseaseSelector";

import {
	useNavigate
} from "react-router-dom";

const CreateBearerStep2_Diseases = ({onNext, onPrevious, diseases, setDiseases}) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [showInfoTooltip, setShowInfoTooltip] = useState(false);

	const { userType, loginToken, userId } = React.useContext(AuthContext);

	const handleNext = async () => {
		setIsLoading(true);
		try {
			await onNext();
		} finally {
			setIsLoading(false);
		}
	};

	const hasAtLeastOneDisease = diseases.length > 0 && diseases.some(d => d.disease_text);

	return (<>
	            <div className="flex items-center justify-center h-full w-full bg-gradient-to-r from-cyan-100 to-green-100">
					<div className="flex flex-col neumorp items-center justify-center space-y-5 bg-white px-6 py-10 sm:p-10 rounded-lg shadow-lg w-full max-w-2xl">
						{/* Logo and Language Switcher */}
						<div className="flex items-center justify-between w-full">
							<img src={logoicon} alt="Tuutuum Logo" className="block h-7 w-auto"/>
							<LanguageSwitcher />
						</div>
						<div className="text-center px-2">
							<div className="flex items-center justify-center gap-2 mb-1">
								<h2 className="text-2xl leading-tight">
									{t("select_disease_of_bearer")}
								</h2>
								<div className="relative">
									<button
										type="button"
										onMouseEnter={() => setShowInfoTooltip(true)}
										onMouseLeave={() => setShowInfoTooltip(false)}
										onClick={() => setShowInfoTooltip(!showInfoTooltip)}
										className="text-cyan-600 hover:text-cyan-700 focus:outline-none"
										aria-label="Information"
									>
										<InformationCircleIcon className="h-5 w-5" />
									</button>
									{showInfoTooltip && (
										<div className="absolute left-1/2 -translate-x-1/2 mt-2 w-64 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg z-10">
											{t("disease_limit_info")}
											<div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45"></div>
										</div>
									)}
								</div>
							</div>
							<p className="text-base text-gray-600 mt-1">
								{t("can_update_anytime")}
							</p>
						</div>
						{/* Multi-disease selector */}
						<div className="flex flex-nowrap w-full gap-4 justify-stretch pt-1">
							<MultiDiseaseSelector
								loginToken={loginToken}
								initialDiseases={diseases}
								onDiseasesChange={setDiseases}
								disabled={isLoading} />
						</div>
						<div className="flex flex-nowrap w-full gap-4 justify-between">
							{/* Buttons */}
							<button
								onClick={onPrevious}
								disabled={isLoading}
								className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
							>
								{t("previous")}
							</button>
							{/* Button */}
							<button
								onClick={handleNext}
								disabled={!hasAtLeastOneDisease || isLoading}
								className="btn-main btn-main:hover text-white px-3 py-1 w-auto rounded-md sm:leading-6 text-center font-semibold text-sm transition ease-in-out hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
							>
							{t("next")}
							</button>
						</div>
					</div>
				</div>
			</>);
}

export default CreateBearerStep2_Diseases;
